;
const homepage_hero_form_submit = e => {
  e.preventDefault();

  const form = e.target;
  const params = new URLSearchParams(new FormData(form));

  for (const [key, value] of [...params.entries()]) {
    if (value.trim() === '') {
      params.delete(key);
    }
  }

  const query = params.toString();
  window.location.href = query ? `${form.action}?${query}` : form.action;
};

(() => {
  if (document.getElementById('homepage-hero-carousel') != null) {
    tns({
      'container': '#homepage-hero-carousel',
      'speed': 400,
      'navPosition': 'bottom',
      'mouseDrag': true,
      'controlsText': ['précédent', 'suivant']
    });
  }
})();
